export default __webpack_public_path__ + "static/media/Plant.d156b0af.jpg";